import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { getContact } from '../actions/portfolioActions'
import ContactsSection from './sections/ContactsSection'

function ContactsPage() {
  const dispatch = useDispatch()
  useEffect(() => { dispatch(getContact()) }, [dispatch])
  return <ContactsSection />
}

export default ContactsPage
